import React from 'react';
import PropTypes from 'prop-types';

const CIRCLE_SIZE = {
  xl: { width: '19px', height: '19px' },
  large: { width: '16px', height: '16px' },
  medium: { width: '13px', height: '13px' },
  small: { width: '10px', height: '10px' },
};

const OUTLINE_SIZE = {
  xl: '6px',
  large: '5px',
  medium: '4px',
  small: '3px',
};

export function Dot({ outlineColor, circleColor, size }) {
  return (
    <span
      className={`block rounded-full`}
      style={{
        backgroundColor: circleColor,
        border: `${OUTLINE_SIZE[size]} solid ${outlineColor}`,
        ...(CIRCLE_SIZE[size] || {}),
      }}
    ></span>
  );
}

Dot.propTypes = {
  circleColor: PropTypes.string.isRequired,

  size: PropTypes.oneOf(['small', 'medium', 'large']),

  outlineColor: PropTypes.string,
};

Dot.defaultProps = {
  circleColor: 'green',
  size: 'small',
  outlineColor: 'red',
};
